import type { AppDispatch } from "@/store";
import { refreshConfig, updateConfig } from "@/store/reducers/configSlice";
import { configStateSelector } from "@/store/selectors/configSelector";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useGetConfig = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const dispatch = useDispatch<AppDispatch>();
  const configState = useSelector(configStateSelector);

  useEffect(() => {
    if (enabled && !configState.updated && !configState.loading) {
      void dispatch(updateConfig());
    }
  }, [dispatch, enabled, configState.loading, configState.updated]);

  return {
    data: configState.data,
    error: configState.error,
    isError: !!configState.error,
    isFetching: configState.loading,
    isLoading: configState.loading,
    refetch: () => dispatch(refreshConfig()),
  };
};